import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { db } from "../../firebase";
import Skeleton from "react-loading-skeleton";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../../Components/Footer/Footer";
import Offerimg from "../../Images/Serviceimg/offerimg.png";
import "../Bathroom/Bathroom.css";
import "react-loading-skeleton/dist/skeleton.css";
import VideoUrl from "../../videos/FullHomeCleaning.mp4";
import { Rate, message } from "antd";
import Loading1 from "../../Components/Loading/Loading1";
import HomeNav from "../../Components/Navbar/NewNavbar";
import FullHomeCleaningInfo from "./FullHomeCleaningInfo";
import Rating from '@mui/material/Rating';
import Box from '@mui/material/Box';
import DiscountIcon from '@mui/icons-material/Discount';
import DetailsModal from '../../Components/DetailsModal/DetailsModal';

const HomeCleaning = () => {
  const [services, setServices] = useState([]);
  const [cart, setCart] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [selectedService, setSelectedService] = useState(null); // To store selected service for modal
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchServices = async () => {
      const servicesCollectionRef = collection(db, "services", "home", "0");
      const querySnapshot = await getDocs(servicesCollectionRef);
      let servicesList = [];
      querySnapshot.forEach((doc) => {
        servicesList.push({ id: doc.id, ...doc.data() });
      });
      setServices(servicesList);
      setLoading(false);
    };

    const fetchVideoUrl = async () => {
      const storage = getStorage();
      const videoRef = ref(
        storage,
        "serviceVideos/FullhomeVideo/CleaningVideo1.mp4"
      );
      try {
        const url = await getDownloadURL(videoRef);
        setVideoUrl(url);
      } catch (error) {
        console.error("Error fetching video URL:", error);
      }
    };

    fetchServices();
    fetchVideoUrl();
    setCart(JSON.parse(localStorage.getItem("cart")) || []);
  }, []);

  const GoToCart = () => {
    navigate("/cart");
  };

  const addToCart = (service) => {
    let cartItems = [...cart];
    const existingIndex = cartItems.findIndex((item) => item.id === service.id);

    if (existingIndex > -1) {
      cartItems[existingIndex].qty += 1;
    } else {
      service.qty = 1;
      cartItems.push(service);
    }

    localStorage.setItem("cart", JSON.stringify(cartItems));
    message.success("Item Added in Cart");
    setCart(cartItems);
  };

  const openDetailsModal = (service) => {
    setSelectedService(service);  // Set the selected service
    setIsOpen(true);  // Open the modal
  };

  const skeletonProps = {
    baseColor: "#ddd",
    highlightColor: "#eee",
  };

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1500);
  }, []);

  if (isLoading) {
    return <Loading1 />;
  }

  return (
    <>
      <HomeNav />
      <div className="container my-5">
        <div className="row">
          <div className="minicart-video">
            <div className="minicart-container1">
              <h1 className="display-4">Full Home Cleaning</h1>
              <h3>
                Astra Clean full home cleaning service delivers a comprehensive,
                top-to-bottom clean for every room in your house. Our
                professional team ensures every corner is dust-free, sanitized,
                and sparkling, creating a fresh and welcoming environment for
                you and your family.
              </h3>
              <div className="service-rating">
                <div className="ratings-service">
                  <div className="rating-title">Average Rating</div>
                  <div className="rating-descreption">
                    <span style={{ fontSize: "25px", fontWeight: "500" }}>
                      4.7
                    </span>
                    <Rate
                      allowHalf
                      defaultValue={4.7}
                      className="ratingcolor"
                      disabled
                    />
                  </div>
                  <div className="rating-year">Average rating this year</div>
                </div>
              </div>
            </div>
            <div className="minicart-container2">
              <div className="minicart-container2-subcontainer">
                <div className="minicart-container2-video">
                  {loading ? (
                    <div className="video-skeleton">
                      <Skeleton height={500} width={800} {...skeletonProps} />
                    </div>
                  ) : (
                    <video src={videoUrl} autoPlay loop muted></video>
                  )}
                </div>
                <div className="minicart-container2-carts">
                  <div className="other-services">
                    {loading
                      ? Array.from({ length: 10 }).map((_, index) => (
                        <Skeleton
                          key={index}
                          height={200}
                          width={600}
                          {...skeletonProps}
                        />
                      ))
                      : services.map((service) => (
                        <div key={service.id} className="col-md-4 my-3">
                          <div className="card service-card">
                            <div className="card-service-card-container">
                              <img
                                src={service.img}
                                className="card-img-top"
                                alt={service.name}
                              />
                              <div className="card-body">
                                <h5
                                  className="card-title"
                                  style={{
                                    textTransform: "capitalize",
                                    color: "black",
                                  }}
                                >
                                  {service.name}
                                </h5>
                                <ul className="card-text">
                                  {(Array.isArray(service.description)
                                    ? service.description
                                    : [service.description]
                                  ).map((point, index) => (
                                    <li key={index}>{point}</li>
                                  ))}
                                </ul>
                                <div className="rating-container">
                                  <span
                                    style={{
                                      fontSize: "20px",
                                      fontWeight: "600",
                                      marginRight: "7px",
                                    }}
                                  >
                                    {service.rating}
                                  </span>
                                  <Box component="div" mt={0.8}>
                                    <Rating
                                      name="rating"
                                      value={service.rating}
                                      precision={0.1}
                                      size="medium"
                                      readOnly
                                    />
                                  </Box>
                                </div>
                              </div>
                            </div>
                            <div className="card-footer">
                              <div className="pricesofservices">
                                <span className="originalprice">
                                  Rs.{service.originalPrice}
                                </span>
                                <span className="price">
                                  Rs.{service.discountedPrice}
                                </span>
                              </div>
                              <div className="btn-cartpage">
                                <button
                                  className="btn btn-add"
                                  onClick={() => addToCart(service)}
                                >
                                  Add to Cart
                                </button>
                                <button
                                  className="btn btn-add"
                                  onClick={() => openDetailsModal(service)} // Open modal with selected service
                                >
                                  View Details
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                  <div className="offers-deiscount">
                    <div className="card-for-each-services">
                      
                    </div>
                    <div className="offer-card">
                      <div className="offer-icon">
                        <span className="icon">
                          <DiscountIcon style={{ color: "green" }} />
                        </span>
                      </div>
                      <div className="offer-details">
                        <h4 className="offer-title">Assured reward from CRED</h4>
                        <p className="offer-subtitle">On all online payments</p>
                        <Link href="#" className="more-offers">
                          View More Offers ▼
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="about-services">
            <FullHomeCleaningInfo />
          </div>
        </div>
      </div>
      <Footer />
      <DetailsModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        service={selectedService} // Pass the selected service to modal
      />
    </>
  );
};

export default HomeCleaning;